// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // Importa ReactDOM para React 18+
import './index.css'; // Si tienes un archivo CSS global
import App from './App'; // Importa tu componente principal App
import { AuthProvider } from './context/AuthContext'; // Importa tu AuthProvider

// Crea una raíz de renderizado para tu aplicación React
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderiza tu componente App dentro del AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);


